import { DataGridErrorState } from '../../common/DataGrid/DataGridErrorState';

interface ScopesTableErrorStateProps {
  message?: string;
}

export function ScopesTableErrorState({
  message = 'There was an error loading the scopes. Please, try again later.',
}: ScopesTableErrorStateProps) {
  return <DataGridErrorState colSpan={5}>{message}</DataGridErrorState>;
}
